import { useFormikContext } from "formik";
import React, { useContext, useEffect } from "react"
import { AlertContext } from "@app/components/AlertContext/AlertContext"
import Button from "@app/components/Button";
import { useFetcher } from "react-router-dom"

export const useWorkplaceObserver = (currentFieldsets) => {
	const { values } = useFormikContext();
	const atWorkplace = values.kundenundeinsatzort_folgebesichtigung_folgebesichtigung_amarbeitsplatz;
	const { showAlert, closeAlert } = useContext(AlertContext);
	const prevValueRef = React.useRef(atWorkplace);
	const fetcher = useFetcher();

	useEffect(() => {
		const prev = prevValueRef.current;

		if (prev !== atWorkplace) {
			if (atWorkplace === "Nein") {
				showAlert({
					renderChildren: () => <>
						<div className={"text-big"}>
							Bitte legen Sie eine neue Begehung an, da sich die/der Mitarbeitende nicht mehr am vereinbarten
							Arbeitsplatz befindet.
						</div>
						<Button
							className={"mt-60 mb-30"}
							label={"Neue Arbeitsplatzbegehung für neuen Arbeitsplatz starten"}
							callback={() => {
								fetcher.submit(
									{ action: "NEW_AND_DELETE" },
									{
										method: "post",
										encType: "application/x-www-form-urlencoded"
									}
								);
								closeAlert();
							}}
							isSubmit={true}
						/>
						<Button
							className={"w-100"}
							label={"Bestehende Folgebesichtigung fortsetzen"}
							type={"secondary"}
							callback={closeAlert}
							isSubmit={true}
						/>
					</>
				});
			}
		}

		prevValueRef.current = atWorkplace;
	}, [atWorkplace, showAlert]);

	return React.useMemo(() => {
		return {
			fieldsets: currentFieldsets,
		};
	}, [currentFieldsets]);
};

const WorkplaceObserver = ({currentFieldsets, setCurrentFieldsets}) => {
	const {fieldsets} = useWorkplaceObserver(currentFieldsets)
	setCurrentFieldsets(fieldsets);
	return null;
};

export default WorkplaceObserver;
